export enum EPages {
  MAIN = 'MAIN',
  BRANDS = 'BRANDS',
}
